import { themeVars } from '@coverflex-tech/hypernova';
import { style } from '@vanilla-extract/css';

const title = style({
  marginBottom: themeVars.spacing.sm,
});

const form = style({
  display: 'flex',
  flexDirection: 'column',
  gap: themeVars.spacing.lg,
  margin: `${themeVars.spacing.lg} 0`,
});

const button = style({
  alignSelf: 'flex-start',
  textTransform: 'none',
});

const links = style({
  display: 'flex',
  alignItems: 'flex-start',
  flexDirection: 'column',
  gap: themeVars.spacing.md,
});

const loading = style({
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: 10,
  width: '100%',
  height: '100%',
  backgroundColor: themeVars.color.semantic.surface.neutral20,
});

export const css = {
  title,
  form,
  button,
  links,
  loading,
};
